import React, { useState } from 'react'
import moment from 'moment'
import styled from 'styled-components'
import ArrowRight from '../../../../components/Images/ChevronRight'
import ArrowLeft from '../../../../components/Images/ChevronLeft'
import { months } from '../../constants'
import './styles.css'

const ArrowRightIcon = styled(ArrowRight)`
  fill: var(--storm-op-64);
  height: 24px;
  width: 24px;
  cursor: pointer;
  margin-left: 8px;
`

const ArrowLeftIcon = styled(ArrowLeft)`
  fill: var(--storm-op-64);
  height: 24px;
  width: 24px;
  cursor: pointer;
  margin-right: 8px;
`

const DateCell = styled.li`
  height: ${({ height }) => height || '48px'};
  grid-column-start: ${({ startDate }) => startDate || 'unset'};
  background-color: ${({ bg }) => bg};
  position: relative;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;

  @media (max-width: 420px) {
    height: ${({ height }) => height || '36px'};
  }
`

const DateText = styled.span`
  font-size: 14px;
  line-height: 1.43;
  text-align: center;
  color: ${({ color }) => color};
  cursor: pointer;
`

const CHAPTER_COLOR_MAPPING = Object.freeze({
  0: '#FF4242',
  1: '#E0FFF6',
  2: '#78FFD8',
  3: '#00CB76',
})

const CHAPTER_DATE_TEXT_COLOR_MAPPING = Object.freeze({
  0: '#FFFFFF',
  1: '#295E48',
  2: '#295E48',
  3: '#FFFFFF',
})

const DailyChapterBonusCalendar = ({ wbpFirstOngoingDate, publishedDates }) => {
  const isMobile = window.screen.width <= 600
  const [showMonthTable, setShowMonthTable] = useState(false)
  const [dateObject, setDateObject] = useState(moment())
  const [allmonths] = useState(moment.months())
  const [previousSelectedDay, setPreviousSelectedDay] = useState(null)

  const daysInMonth = () => dateObject.daysInMonth()
  const year = () => dateObject.format('Y')
  const month = () => dateObject.format('MMMM')

  const firstDayOfMonth = () => {
    const firstDay = moment(dateObject).startOf('month').format('d')
    return firstDay
  }

  const increasetMonth = (newMonth) => {
    if (previousSelectedDay) {
      const el1 = document.getElementById(`calendar-day-${previousSelectedDay}`)
      el1.style.height = isMobile ? '36px' : '48px'
    }

    let monthNo = allmonths.indexOf(newMonth)
    monthNo++
    const newDateObject = moment(dateObject).set('month', monthNo)

    setDateObject(newDateObject)
    setShowMonthTable(!showMonthTable)
    setPreviousSelectedDay(null)
  }

  const decreasetMonth = (newMonth) => {
    if (previousSelectedDay) {
      const el1 = document.getElementById(`calendar-day-${previousSelectedDay}`)
      el1.style.height = isMobile ? '36px' : '48px'
    }

    let monthNo = allmonths.indexOf(newMonth)
    monthNo--
    const newDateObject = moment(dateObject).set('month', monthNo)

    setDateObject(newDateObject)
    setShowMonthTable(!showMonthTable)
    setPreviousSelectedDay(null)
  }

  const list = [
    <li className="day-name-bonus" key="Sun">
      Sun
    </li>,
    <li className="day-name-bonus" key="Mon">
      Mon
    </li>,
    <li className="day-name-bonus" key="Tue">
      Tue
    </li>,
    <li className="day-name-bonus" key="Wed">
      Wed
    </li>,
    <li className="day-name-bonus" key="Thu">
      Thu
    </li>,
    <li className="day-name-bonus" key="Fri">
      Fri
    </li>,
    <li className="day-name-bonus" key="Sat">
      Sat
    </li>,
  ]

  const monthIndex = months.findIndex((mon) => mon === month().substr(0, 3))
  const firstApprovedDate = new Date(wbpFirstOngoingDate)
  const isApprovedMonthAndYear =
    months[firstApprovedDate.getMonth()] === month().substr(0, 3) &&
    firstApprovedDate.getFullYear().toString() === year()

  for (let d = 1; d <= daysInMonth(); d++) {
    const fullDate = `${`0${d}`.slice(-2)}/${`0${monthIndex + 1}`.slice(
      -2
    )}/${year()}`.toString()
    const dateObj = publishedDates?.[fullDate]
    const bg = dateObj?.chapter_count
      ? CHAPTER_COLOR_MAPPING[
          dateObj?.chapter_count > 3 ? 3 : dateObj?.chapter_count
        ]
      : dateObj?.chapter_count === 0
      ? '#FF4242'
      : '#e9f4fb'

    list.push(
      <DateCell
        id={`calendar-day-${d}`}
        startDate={d === 1 && Number(firstDayOfMonth()) + 1}
        bg={bg}
        height={
          !isMobile &&
          (dateObj?.chapter_count === 0 || dateObj?.chapter_count) &&
          '48px'
        }
        key={d}
      >
        <DateText
          color={
            dateObj?.chapter_count
              ? CHAPTER_DATE_TEXT_COLOR_MAPPING[
                  dateObj?.chapter_count > 3 ? 3 : dateObj?.chapter_count
                ]
              : dateObj?.chapter_count === 0
              ? '#ffffff'
              : '#A4A6B0'
          }
        >
          {d}
        </DateText>
      </DateCell>
    )
  }

  return (
    <div id="daily-calendar" className="daily-chapter-bonus-calendar">
      <div className="calendar-navi">
        {!isApprovedMonthAndYear && (
          <ArrowLeftIcon onClick={() => decreasetMonth(month())} />
        )}
        {month()} {year()}
        <ArrowRightIcon onClick={() => increasetMonth(month())} />
      </div>
      <div id="calendar-box">
        <ol className="calendar" id="day-list">
          {list}
        </ol>
      </div>
    </div>
  )
}

export default DailyChapterBonusCalendar
